import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { CommunityPreviewDeviceMeta } from "@eweadn-qiankun/shared-types";
import { MouseVisualizer } from "../../../../../mouse-management/src/pages/changeKey/MouseVisualizer";
import {
  getMouseButtonMappings,
  getMouseRemappedButtonIds,
} from "../utils/mouseConfigPreviewUtils";
import "../../../../../mouse-management/src/pages/changeKey/index.scss";
import "../../../../../mouse-management/src/pages/changeKey/Mouse.scss";

interface Props {
  meta: CommunityPreviewDeviceMeta;
  configData?: Record<string, unknown>;
}

export default function MouseChangeKeySection({ meta, configData }: Props) {
  const { t } = useTranslation();

  const defaultLabels = useMemo(
    () => ({
      left: t("mouse.changeKey.leftButton"),
      middle: t("mouse.changeKey.middleButton"),
      right: t("mouse.changeKey.rightButton"),
      side1: t("mouse.changeKey.backward"),
      side2: t("mouse.changeKey.forward"),
      scrollUp: t("mouse.changeKey.scrollUp"),
      scrollDown: t("mouse.changeKey.scrollDown"),
      dpi: t("mouse.changeKey.dpiCycle"),
    }),
    [t]
  );

  const buttonMappings = useMemo(
    () =>
      getMouseButtonMappings(
        configData,
        defaultLabels,
        t,
        meta.solutionProvider
      ),
    [configData, defaultLabels, t, meta.solutionProvider]
  );

  const remappedButtonIds = useMemo(
    () => getMouseRemappedButtonIds(buttonMappings, defaultLabels),
    [buttonMappings, defaultLabels]
  );

  return (
    <div className="community-mouse-changekey-preview changekey-page">
      <div className="changekey-left">
        <MouseVisualizer
          deviceId={meta.mouseDeviceId}
          displayname={meta.displayname}
          selectedButtonId={null}
          onButtonSelect={() => undefined}
          buttonMappings={buttonMappings}
          highlightedButtonIds={remappedButtonIds}
          hideReset
          readOnly
        />
      </div>
    </div>
  );
}
